import { BaseObjectQueryFactory } from "../base-object/base-object.query-factory";
import { User } from "./user.model";
import { UserFilters } from "./user.reducer";

export class UserQueryFactory extends BaseObjectQueryFactory<User, UserFilters> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.queries.ts